let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("koawN")).then(() => parcelRequire('k7TQm'));